import React, {useCallback, useEffect, useRef, useState} from "react";
import {Column, FilterRow, Pager, Paging, Scrolling, Selection, TreeList} from "devextreme-react/tree-list";
import './points-tree.scss'
import StorageService from "../../services/storage.service";
import ObjNameCell, {objNameFilterValue} from "./obj-name-cell";

export default function TreeHook(props) {
  const treeDataSource = props.points
  const selectionMode = props.selectionMode
  const onSelect = props.onSelect
  const shouldAllowSelectionChange = props.shouldAllowSelectionChange
  const treeRef = props.treeRef

  let treeViewRef = useRef();
  const [treeBoxValue, setTreeBoxValue] = useState([]);
  const treeBoxValueRef = useRef([]);
  const suppressSelectionEventRef = useRef(false);
  const autoSelectedRef = useRef(false);
  treeBoxValueRef.current = treeBoxValue;

    useEffect(() => {
        if (!treeDataSource || !Array.isArray(treeDataSource) || treeDataSource.length === 0) {
            autoSelectedRef.current = false;
            return;
        }
        if (autoSelectedRef.current) return;
        autoSelectedRef.current = true;

        const groups = treeDataSource.filter(e => e.isG);
        const leafs = treeDataSource.filter(e => !e.isG);

        if (groups.length === 1 && leafs.length === 1) {
            const ids = selectionMode === 'single'
                ? [leafs[0].id]
                : [groups[0].id, leafs[0].id];
            setTreeBoxValue(ids);
            StorageService.setLocalPoints(ids);
            const treeView = treeViewRef.current && treeViewRef.current.instance;
            if (treeView) {
                treeView.selectRows(ids);
            }
        } else {
            setTreeBoxValue([]);
        }
    }, [treeDataSource, selectionMode])

    const isHandlerSet = useRef(false);

    useEffect(() => {
        setTimeout(adjustDivHeight,0);
        if (!isHandlerSet.current) {
            window.addEventListener('resize', adjustDivHeight);
            //window.addEventListener('wheel', adjustDivHeight);
            isHandlerSet.current = true;
            //console.log('Обработчик resize установлен');
        }

        return () => {
            if (isHandlerSet.current) {
                window.removeEventListener('resize', adjustDivHeight);
                //window.addEventListener('wheel', adjustDivHeight);
                isHandlerSet.current = false;
                //console.log('Обработчик resize удален');
            }
        };
    }, []);

    /*useEffect(() => {
        const targetElement = document.querySelector(".tree-hook-left")
        if (!targetElement) return;
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { height } = entry.contentRect;
                //console.log('Элемент изменил размер:', width, height);
                const div = document.getElementById("tree-energoobjects"); // Получаем div по ID
                div.style.height = `${height}px`;
                // Здесь можно добавить вашу логику
            }
        });
        observer.observe(targetElement);
        return () => {
            observer.unobserve(targetElement);
        };
    }, []);*/

    /*const resetSizeTree = () => {
        const div = document.getElementById("tree-energoobjects"); // Получаем div по ID
        if (div) div.style.height = `${500}px`;
        adjustDivHeight()
    }*/

  const syncSelection = useCallback((treeView) => {
    try {
        onSelect(treeView)
    } catch (e) {
        onSelect([])
    }
  },[onSelect])

  const syncTreeViewSelection = useCallback(
    (e) => {
      let treeView =
        (e.component.selectItem && e.component) ||
          (treeViewRef.current && treeViewRef.current.instance);
      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll();
        } else {
          let values = e.value || treeBoxValue;
          values &&
          treeView.selectRows(values);
        }

      }

      if (e.value !== undefined) {
        setTreeBoxValue(e.value)
      }
    },
    [treeBoxValue]
  );

    const treeView_itemSelectionChanged = useCallback((e) => {
        if (suppressSelectionEventRef.current) return
        const selectedRows = e.component.getSelectedRowsData(selectionMode)
        if (shouldAllowSelectionChange && !shouldAllowSelectionChange(selectedRows)) {
            suppressSelectionEventRef.current = true
            e.component.selectRows(treeBoxValueRef.current || [], false)
            suppressSelectionEventRef.current = false
            return
        }
        const LocalPointsIds = selectedRows.map((obj) => obj.id)
        setTreeBoxValue(LocalPointsIds)
        StorageService.setLocalPoints(LocalPointsIds)
        syncSelection(selectedRows)
        },
    [syncSelection, selectionMode, shouldAllowSelectionChange]
  );

    function adjustDivHeight() {
        const div = document.getElementById("tree-energoobjects"); // Получаем div по ID
        if (!div) return; // Проверяем, существует ли элемент
        // Получаем верхнюю координату div относительно документа
        const divTop = div.getBoundingClientRect().top + window.scrollY;
        // Получаем нижнюю координату документа (высота всего документа)
        const docBottom = document.documentElement.scrollHeight;
        // Вычисляем новую высоту: разница между нижней границей документа и верхней границей div минус 20px
        const newHeight = docBottom - divTop - 20;
        // Устанавливаем новую высоту div (в пикселях)
        div.style.height = `${newHeight}px`;
        //console.log(`Новая высота div: ${newHeight}px`);
    }


  return (
      <TreeList
          showColumnHeaders={true}
          id="tree-energoobjects"
          ref={(el) => {
              treeViewRef.current = el
              if (treeRef) treeRef.current = el
          }}
          dataSource={treeDataSource}
          autoExpandAll={true}
          columnAutoWidth={true}
          showBorders={true}
          showColumnLines={false}
          dataStructure="plain"
          parentIdExpr="pId"
          keyExpr="id"
          onSelectionChanged={treeView_itemSelectionChanged}
          onNodesInitialized={syncTreeViewSelection}
          onContentReady={syncTreeViewSelection}
          loadPanel={{enabled:false}}
          filterMode={'fullBranch'}
      >
          <FilterRow visible={true} />
          <Selection mode={selectionMode} recursive={true}/>
          <Scrolling preloadEnabled={true} mode="virtual" />
          <Paging
              enabled={true}
              defaultPageSize={20} />
          <Pager
              showPageSizeSelector={true}
              allowedPageSizes={"auto"}
              showInfo={true} />
          <Column
              dataField="t"
              caption="Название"
              cellComponent={ObjNameCell}
              calculateCellValue={objNameFilterValue}>
          </Column>
          {window.location.hash === '#/energoobjects' &&
          <Column
              dataField="askue"
              width={40}
              allowFiltering={false}
              caption=''
              cellComponent={(props) => {
                  const askue = props.data.data.askue;
                  if (askue && props.data.data.id.includes('_')) {
                      return <i className="dx-icon-chart main-color-light"></i>
                  }
                  return (
                      <></>
                  );
              }}
          />
          }
      </TreeList>
  );
}
